import { timeAgo } from '@/utils/datetime';
import { useState } from 'react';

export function TimeAgo({ timestamp }: { timestamp: any }) {
  const [useTimeAgo, setTimeAgo] = useState(true);

  return (
    <span className="text-xs text-gray-500 cursor-pointer" onClick={() => setTimeAgo(!useTimeAgo)}>
      { useTimeAgo
        ? timeAgo.format(new Date(timestamp))
        : new Date(timestamp).toLocaleString()}
    </span>
  )
}
